export var returnCodes = {
    Success: 'Success',
    Failure: 'Failure',
    OperationNotSupported: 'OperationNotSupported',
    ServiceUnavailable: 'ServiceUnavailable',
    UnknownError: 'UnknownError'
};

export var biscReturnCode = {
    ServiceUnavailable	    :   503
  , InternalError           :   -1
  , BadBrandingSignature    :   -2
  , InsertCard              :   -3
  , WrongCard               :   -4
  , RedPin                  :   -5
  , NoCardReader            :   -6
  , BiscCertNotFound        :   -7
  , WrongCA                 :   -8
  , RedPinX                 :   -9
  , WrongTime               :   -10
  , ServiceBusy             :   -11
  , WrongRecipient          :   -12
  , CommErr                 :   -13
  , NoEidCard               :   -14
  , UnknownEidCert          :   -15
  , SwitchedCard            :   -16
  , InactiveCard            :   -17
  , UserCancelled           :   -18
  , NoPinpad                :   -19
  , BlockedPin              :   -20
  , WrongUser               :   -21
  , TimeoutError            :   -22
  , PINpadErr               :   -23
  , SCardErr                :   -24
  , FailedGetCert           :   -25
  , ConfigError             :   -26
  , NoIsabelReader          :   -27
  , OrangePin               :   -28
  , UnsupportedBrowser      :   -29
};

const ISABEL_CSPX_OK = 0;
export const IsabelErrors = {
      ISABEL_CSPX_OK                              : ISABEL_CSPX_OK
    , ISABEL_CSPX_MEM_ERROR                       : ISABEL_CSPX_OK-1
    , ISABEL_CSPX_ACQUIRECONTEXT_FAILED           : ISABEL_CSPX_OK-2
    , ISABEL_CSPX_RELEASECONTEXT_FAILED           : ISABEL_CSPX_OK-3
    , ISABEL_CSPX_CREATEHASH_FAILED               : ISABEL_CSPX_OK-4
    , ISABEL_CSPX_HASHDATA_FAILED                 : ISABEL_CSPX_OK-5
    , ISABEL_CSPX_GETHASHPARAM_FAILED             : ISABEL_CSPX_OK-6
    , ISABEL_CSPX_SIGNATURE_ERROR                 : ISABEL_CSPX_OK-10
    , ISABEL_CSPX_SIGNHASH_FAILED                 : ISABEL_CSPX_OK-14
    , ISABEL_CSPX_RADIX_ERROR                     : ISABEL_CSPX_OK-16
    , ISABEL_CSPX_SETPROVPARAM_FAILED             : ISABEL_CSPX_OK-17
    , ISABEL_CSPX_CANCEL                          : ISABEL_CSPX_OK-18
    , ISABEL_CSPX_ISABEL_CARD_NOT_FOUND           : ISABEL_CSPX_OK-19
    , ISABEL_CSPX_CERTIFICATE_NOT_FOUND           : ISABEL_CSPX_OK-23
    , ISABEL_CSPX_CERTENUMSTORE_FAILED            : ISABEL_CSPX_OK-25
    , ISABEL_CSPX_CERTIFICATE_VERIFICATION_ERROR  : ISABEL_CSPX_OK-26
    , ISABEL_CSPX_SIGNING_BUSY                    : ISABEL_CSPX_OK-27
    , ISABEL_CSPX_VERIFY_ERROR                    : ISABEL_CSPX_OK-28
    , ISABEL_CSPX_CERTOPENSTORE_FAILED            : ISABEL_CSPX_OK-29
    , ISABEL_CSPX_CERTDECODEOBJECTFAILED_FAILED   : ISABEL_CSPX_OK-30
    , ISABEL_CSPX_SSL_VERIFY_ERROR                : ISABEL_CSPX_OK-31
    , ISABEL_CSPX_CARD_SWITCHED                   : ISABEL_CSPX_OK-32
    , ISABEL_CSPX_CARD_NOT_ACTIVE                 : ISABEL_CSPX_OK-33
    , ISABEL_CSPX_FORCE_PINPAD_ERROR              : ISABEL_CSPX_OK-34
    , ISABEL_CSPX_PIN_LOCKED                      : ISABEL_CSPX_OK-35
    , ISABEL_CSPX_EPAYMENT_PKIUID_MISMATCH        : ISABEL_CSPX_OK-36
    , ISABEL_CSPX_TIMEOUT                         : ISABEL_CSPX_OK-37
    
    // CSP Extended error codes
    , PP_EXT_BAD_BRANDING_SIGNATURE               : -201
    , PP_EXT_INACTIVE_CARD                        : -202
    , PP_EXT_WRONG_USER                           : -203
    , PP_EXT_WRONG_CARD                           : -204
    , PP_EXT_RED_PIN                              : -205
    , PP_EXT_RED_PIN_X                            : -206
    , PP_EXT_BLOCKED_PIN                          : -207
    , PP_EXT_WRONG_CA                             : -208
    , PP_EXT_WRONG_TIME                           : -209
    , PP_EXT_WRONG_RECIPIENT                      : -210
    , PP_EXT_COMMUNICATION_ERROR                  : -211
    , PP_EXT_SMARTCARD_ERROR                      : -212
    , PP_EXT_FAILED_GET_CERT                      : -213
    , PP_EXT_NO_CARD_READER                       : -214
    , PP_EXT_PINPAD_ERROR                         : -215
    , PP_EXT_CONFIG_ERROR                         : -216
    , PP_EXT_NO_ISABEL_READER                     : -217
    , PP_EXT_NO_PINPAD_READER                     : -218
    , PP_EXT_ORANGE_PIN                           : -219
    
    , ISABEL_P11_GET_SLOT_LIST_FAILED             : ISABEL_CSPX_OK-100
    , ISABEL_P11_GET_NO_SLOTS_FOUND               : ISABEL_CSPX_OK-101
    , ISABEL_P11_INITIALIZATION_ERROR             : ISABEL_CSPX_OK-102
    , ISABEL_P11_GET_TOKENINFO_ERROR              : ISABEL_CSPX_OK-103
    , ISABEL_P11_OPENSESSION_ERROR                : ISABEL_CSPX_OK-104
    , ISABEL_P11_SIGNINIT_ERROR                   : ISABEL_CSPX_OK-105
    , ISABEL_P11_SIGNUPDATE_ERROR                 : ISABEL_CSPX_OK-106
    , ISABEL_P11_SIGNFINAL_ERROR                  : ISABEL_CSPX_OK-107
    , ISABEL_P11_CLOSESESSION_ERROR               : ISABEL_CSPX_OK-108
    , ISABEL_P11_FINALIZE_ERROR                   : ISABEL_CSPX_OK-109
    , ISABEL_P11_UNKNOWN_HASHALGO                 : ISABEL_CSPX_OK-110
    , ISABEL_P11_GETCACERTIFICATE_ERROR           : ISABEL_CSPX_OK-111
    , ISABEL_P11_CERTIFICATE_DECODE_ERROR         : ISABEL_CSPX_OK-112
    , ISABEL_P11_FIND_OBJECTS_ERROR               : ISABEL_CSPX_OK-113
    , ISABEL_P11_CERTIFICATE_CONVERT_ERROR        : ISABEL_CSPX_OK-114
    , ISABEL_P11_INVALID_HASH                     : ISABEL_CSPX_OK-115
    , ISABEL_P11_CERTIFICATE_NOT_FOUND            : ISABEL_CSPX_OK-116
    , ISABEL_P11_DECRYPTINIT_ERROR                : ISABEL_CSPX_OK-117
    , ISABEL_P11_DECRYPTUPDATE_ERROR              : ISABEL_CSPX_OK-118
    
    , ISABEL_NO_EID_CARD_FOUND                    : ISABEL_CSPX_OK-61
    , ISABEL_UNKOWN_CERTIFICATE_ID                : ISABEL_CSPX_OK-62
    
    , ISABEL_CSPX_GENERAL_ERROR                   : ISABEL_CSPX_OK-666
};